import { useEffect } from 'react';

import * as dateFns from 'date-fns';
import { useFinanceContext } from 'src/components/plaid/datasource';

export const useYTDMonthly = (dataSource, key) => {
  // const { setDateRange, transactions, setDataSource } = useFinanceContext();
  // Preset for the view;
  // useEffect(() => {
  //   // if (process.env.REACT_APP_ENV === 'development') return;
  //   const now = new Date();
  //   const startDate = dateFns.startOfYear(now);
  //   const endDate = dateFns.endOfMonth(now);
  //   setDateRange({ startDate, endDate });
  //   if (dataSource) setDataSource(dataSource);
  // }, [transactions, dataSource, `${key}`]);
};

export const use30Years = (dataSource, key) => {
  // if (process.env.REACT_APP_ENV === 'development') return;
  // const { setDateRange, transactions, setDataSource } = useFinanceContext();
  // Preset for the view;
  // useEffect(() => {
  //   const now = new Date();
  //   const startDate = dateFns.startOfYear(now);
  //   const endDate = dateFns.endOfYear(dateFns.addYears(now, 30));
  //   setDateRange({ startDate, endDate });
  //   if (dataSource) setDataSource(dataSource);
  // }, [transactions, dataSource, key]);
};

export const useEndOfYear = () => {
  const { setDataSource, setDateRange, transactions } = useFinanceContext();

  // Preset for the view;
  useEffect(() => {
    const now = new Date();
    const startDate = dateFns.startOfMonth(now);
    const endDate = dateFns.endOfYear(dateFns.addYears(startDate, 10));

    setDateRange({ startDate, endDate });
    setDataSource('budget');
  }, [transactions]);
};
